import { h } from 'preact';
import { useMemo, useRef } from 'preact/hooks';
import { getProductColor } from 'utils/helpers';
import ProductSwatch from './product-swatch';

const ProductCardSwatches = ({
  products,
  currentProduct,
  onChange,
  initHasLowInventory,
  template,
  ...props
}) => {
  const swatchesCount = 5;
  const label = useRef(null);

  const color = useMemo(
    () => getProductColor(currentProduct),
    [currentProduct],
  );

  const swatches = products.slice(0, swatchesCount);

  return (
    <div {...props}>
      <div className="flex z-20 mb-8 gap-6 lg:gap-8 ml:gap-8 ml:lg:justify-center flex-wrap relative">
        {products.length > 1 && (
          <div className="lc:hidden body-6 ml:lowercase text-subdued ml:lg:absolute ml:lg:h-full ml:lg:right-0 hidden lg:flex items-center lg:group-hover:hidden">
            {window.TMW.Strings.product.moreColors.replace(
              '{{amount}}',
              products.length - 1,
            )}
          </div>
        )}
        <div className="flex items-center ml:lg:hidden ml:lg:group-hover:flex ml:lg:absolute ml:lg:right-0">
          {swatches.map((product) => (
            <ProductSwatch
              key={product.id}
              product={product}
              onChange={onChange}
              initHasLowInventory={initHasLowInventory}
              selected={currentProduct.id === product.id}
              template={template}
            />
          ))}
          {products.length - swatchesCount > 1 && (
            <div className="body-6 text-center pl-4">
              +{products.length - swatchesCount}
            </div>
          )}
        </div>

        <div
          className="flex-none body-3 text-subdued lc:lg:pl-0 ml:lg:mx-auto"
          ref={label}
        >
          {color || 'Default'}
        </div>
      </div>
    </div>
  );
};

export default ProductCardSwatches;
